import { js_beautify } from "js-beautify";
// import { minify } from "minify";

export function getJSBeautifyString(_ref) {
  var input = _ref.input,
    encodingRadio = _ref.encodingRadio,
    _ref$selectedSpaces = _ref.selectedSpaces,
    selectedSpaces = _ref$selectedSpaces === void 0 ? 2 : _ref$selectedSpaces;
  if (encodingRadio === "beautify") {
    return js_beautify(input, {
      indent_size: selectedSpaces,
      space_in_empty_paren: false
    });
  }
  // return minify(input);
}